var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AlertService } from '../../shared/services/alert.service';
import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Scale } from "../../shared/models/scale";
import { AssessmentService } from "../../shared/services/assessment.service";
var ScaleAvailableDisplay = /** @class */ (function (_super) {
    __extends(ScaleAvailableDisplay, _super);
    function ScaleAvailableDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ScaleAvailableDisplay;
}(Scale));
var ScaleEditComponent = /** @class */ (function () {
    function ScaleEditComponent(_assessmentService, route, alertService, router) {
        this._assessmentService = _assessmentService;
        this.route = route;
        this.alertService = alertService;
        this.router = router;
        this._scale = new Scale();
        this._scale.id = this._assessmentService.newId();
        this._hasLoaded = false;
    }
    ScaleEditComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.params.subscribe(function (params) {
            var assessmentUid = params['uid'];
            var scaleId = params['scaleId'];
            _this._assessmentService.getAssessment(assessmentUid)
                .then(function (assessment) {
                _this._assessment = assessment;
                _this._scale = assessment.scales.find(function (s) { return s.id == scaleId; });
                _this._hasLoaded = true;
                if (!_this._scale) {
                    _this.router.navigate(['/not-found']);
                }
            })
                .catch(function (error) {
                _this.alertService.error("There was an error loading the scale data. Check your internet connection and refresh the page.");
                console.error(error);
            });
        });
    };
    Object.defineProperty(ScaleEditComponent.prototype, "hasLoaded", {
        get: function () {
            return this._hasLoaded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleEditComponent.prototype, "scale", {
        get: function () {
            return this._scale;
        },
        set: function (v) {
            this._scale = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleEditComponent.prototype, "AvailableSubScales", {
        get: function () {
            var subScaleDisplayList = [];
            var availableScales = this._scale.getAvailableSubScales(this._assessment.scales);
            availableScales.forEach(function (available, scale) {
                var subScaleDisplay = Object.assign(new ScaleAvailableDisplay(), scale);
                subScaleDisplay.available = available;
                subScaleDisplayList.push(subScaleDisplay);
            });
            return subScaleDisplayList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleEditComponent.prototype, "ScaleTypes", {
        get: function () {
            return ["Sum", "CriteriaThreshold", "Mean"];
        },
        enumerable: true,
        configurable: true
    });
    ScaleEditComponent.prototype.toggleSubScale = function (scale) {
        if (this._scale.hasSubScale(scale)) {
            this._scale.removeSubScale(scale);
        }
        else {
            this._scale.addSubScale(scale);
        }
    };
    ScaleEditComponent.prototype.isSelected = function (subScale) {
        return this._scale.hasSubScale(subScale);
    };
    ScaleEditComponent.prototype.updateType = function (type) {
        this._scale.type = type;
        if (type == "Sum") {
            this.scale.gradingData = { requiredQuestion: 0, requiredScoreThreshold: 0 };
        }
    };
    ScaleEditComponent.prototype.save = function () {
        var _this = this;
        this._assessmentService.saveAssessment(this._assessment).then(function () {
            _this.alertService.success("Scale Saved!");
        }).catch(function (error) {
            _this.alertService.error("Error occurred in saving. Please try again.");
            console.error(error);
        });
    };
    ScaleEditComponent.prototype.saveAndCreateNew = function () {
        var _this = this;
        this._assessmentService.saveAssessment(this._assessment).then(function (assessment) {
            _this._messages.saveSuccess = true;
            setTimeout(function () {
                // we replace the url so we our back button can handle saving properly.
                _this.router.navigate(["../../", "new"], { relativeTo: _this.route, replaceUrl: true });
            });
        })
            .catch(function (error) {
            console.log(error);
            _this.alertService.error("Error occurred in saving. Please try again.");
        });
    };
    ScaleEditComponent.prototype.deleteRange = function (range) {
        var _this = this;
        if (!confirm("Are you sure you want to delete this range?")) {
            return;
        }
        this.scale.removeRange(range);
        this._assessmentService.saveAssessment(this._assessment).then(function () {
            _this.alertService.success("Range Deleted!");
        })
            .catch(function (error) {
            console.log(error);
            _this.alertService.success("Error occurred in deleting. Please try again.!");
        });
    };
    return ScaleEditComponent;
}());
export { ScaleEditComponent };



// WEBPACK FOOTER //
// ./src/app/admin/scale-edit/scale-edit.component.ts.pre-build-optimizer.js